import { useRouteMatch } from 'react-router-dom';
import { IS_DEV } from '../../lib/config';
import extractUrlDetails from './extractUrlDetails';
import { BaseRoutes } from './types';

const useModuleRoute = (): BaseRoutes => {
  const { path, url } = useRouteMatch();

  if (!IS_DEV) {
    const { serviceName } = extractUrlDetails(window.location.pathname);
    if (serviceName) {
      const appServiceUrl = url.split(serviceName)[0];
      const appServicePath = path.split(serviceName)[0];
      return {
        moduleUrl: `${appServiceUrl}${serviceName}`,
        modulePath: `${appServicePath}${serviceName}`,
        communicationUrl: `${appServiceUrl}communication`,
        dataUrl: `${appServiceUrl}data`,
        payUrl: `${appServiceUrl}pay`,
        usersUrl: `${appServiceUrl}users`,
      };
    }
  }

  return {
    moduleUrl: '',
    modulePath: '',
    communicationUrl: '',
    dataUrl: '',
    payUrl: '',
    usersUrl: '',
  };
};

export default useModuleRoute;
